import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema } from '@tom-ui/ui'
import { FC } from 'react'

export type HoldTypeStatus = 'Active' | 'Inactive'

interface Props {
  status: HoldTypeStatus
}

export const HoldTypeStatusChip: FC<Props> = ({ status }) => {
  const { t } = useTranslate()

  const colorMap: Record<HoldTypeStatus, ColorSchema> = {
    Active: 'success',
    Inactive: 'warning',
  }

  const labelMap: Record<HoldTypeStatus, string> = {
    Active: t('active', 'Active'),
    Inactive: t('inactive', 'Inactive'),
  }

  return (
    <Box>
      <ColoredLabel
        label={labelMap[status]}
        color={colorMap[status]}
        sx={{ width: 'fit-content' }}
      />
    </Box>
  )
}
